const PATHWAY_TO_NET_ZERO = "the-pathway-to-net-zero";

export const isPathway = (path?: string | string[]) =>
  PATHWAY_TO_NET_ZERO === path;
